// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/frontend.scss
// module id = 61
// module chunks = 1